export default [
  {
    path: 'product-revenue-report',
    name: 'report-product-revenue-report',
    component: () =>
      import('@/view/pages/product-revenue-report/ProductRevenueReport.vue'),
    meta: {
      title: 'Báo cáo doanh thu sản phẩm - CLICKBUY',
    },
  },
];

